import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from './auth.service';
// Import our authentication service

@Injectable()
export class SetupGuard implements CanActivate {
  constructor(private auth: AuthenticationService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.auth.isAuthModuleSetup().pipe(
      tap(() => {
        return true;
      })
    );
  }
}
